/**
 * Liest den Event-Typ fuer die Darstellung aus einem Storyblok-Content.
 *
 * Reisen sind ein eigener Content-Type (`travel`) und haben deshalb kein
 * `category`-Feld. Etikett, Maskenfarbe und der CTA-Text "Mehr erfahren"
 * haengen aber weiterhin am Wert `"reisen"` — er bleibt also, nur seine
 * Herkunft wechselt vom Feldwert zum Typ.
 *
 * Ohne diese Ableitung faellt jede konvertierte Reise auf `""` zurueck und
 * verliert Etikett und CTA-Text, ohne dass ein Fehler auftritt.
 */
export function eventTypeFromContent(content: {
  component?: string;
  category?: unknown;
}): string {
  if (content.component === "travel") return "reisen";
  return content.category ? String(content.category) : "";
}
